var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLens(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.714 9.429h-.685L9.77 9.17a5.365 5.365 0 001.372-3.6A5.56 5.56 0 005.57 0 5.56 5.56 0 000 5.571a5.56 5.56 0 005.571 5.572 5.365 5.365 0 003.6-1.372l.258.258v.685L13.714 15 15 13.714 10.714 9.43zm-5.143 0A3.841 3.841 0 011.714 5.57a3.841 3.841 0 013.857-3.857A3.841 3.841 0 019.43 5.571 3.841 3.841 0 015.57 9.43z",
    fill: "#6373A4",
    fillRule: "evenodd"
  })));
}

export default SvgLens;